/**
 * 环境配置文件
 * 通过 .env.development / .env.production 控制
 */
const CONFIG = {
  development: {
    baseUrl: process.env.VUE_APP_BASE_API
  },
  production: {
    baseUrl: process.env.VUE_APP_BASE_API
  }
}

export default CONFIG[process.env.NODE_ENV] || CONFIG.development